const dataWarrantyStatus = {
	"yearsRemain": "years remain",
	"monthsRemain": "months remain",
	"daysRemain": "days remain",
	"dayRemains": "day remains"
}

export default dataWarrantyStatus